export default "__VITE_ASSET__CLzex8FB__"